import { render, staticRenderFns } from "./BlacklistPanel.vue?vue&type=template&id=f6f3bd20&scoped=true&"
import script from "./BlacklistPanel.vue?vue&type=script&lang=js&"
export * from "./BlacklistPanel.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistPanel.vue?vue&type=style&index=0&id=f6f3bd20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f3bd20",
  null
  
)

export default component.exports